import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class CustomerSearchService {
  hostUrl: any = environment.API_BASE_URL;
  urlToQuery: any = this.hostUrl + 'api/searchCustomers/?searchString=';
  urlToFindCustomer: any = this.hostUrl + 'api/findCustomer';

  constructor(private _http: HttpClient) {}

  search(terms: Observable<string>) {
    return terms
      .debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => (term ? this.searchEntries(term) : Observable.of([])));
  }

  searchEntries(term) {
    console.log(term);
    if (term.length > 0) {
      return this._http.get(this.urlToQuery + term).map((res: any = Response) => res);
    } else {
      return null;
    }
  }

  findCustomer(data): Observable<any> {
    return this._http.post(this.urlToFindCustomer, data).map((res: Response) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/customer-search.service.ts